export default __webpack_public_path__ + "static/media/GWAS-multi.2c9e02ba.png";